import { render, staticRenderFns } from "./CareGoals.vue?vue&type=template&id=549e0ac9&scoped=true"
import script from "./CareGoals.vue?vue&type=script&lang=ts"
export * from "./CareGoals.vue?vue&type=script&lang=ts"
import style0 from "./CareGoals.vue?vue&type=style&index=0&id=549e0ac9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549e0ac9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('549e0ac9')) {
      api.createRecord('549e0ac9', component.options)
    } else {
      api.reload('549e0ac9', component.options)
    }
    module.hot.accept("./CareGoals.vue?vue&type=template&id=549e0ac9&scoped=true", function () {
      api.rerender('549e0ac9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/ClientTabsComponents/Steps/ClientProfileSteps/CareGoals.vue"
export default component.exports